import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-blocco-allegati',
  templateUrl: './blocco-allegati.component.html',
  styles: ['.black{color:black}']
})
export class BloccoAllegatiComponent implements OnInit {

  constructor() { }

  @Input() campi;
  @Input() painted = false;

  filePath = environment.allegati.filePath;

  ngOnInit() {
  }

  download(allegato) {
    const URL = this.filePath + allegato.path;
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = URL;
    a.target = '_blank';
    a.download = allegato.fileName;
    a.click();
    window.URL.revokeObjectURL(URL);
    a.remove();
  }

}
